import React, { Component } from 'react'
import { firebaseRef } from 'config'
import { connect } from 'react-redux'
import { hijackUser } from 'actions/auth'
import { routeActions } from 'react-router-redux'

class AdminPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      users: [],
      query: ''
    }
    this.filteredUsers = this.filteredUsers.bind(this)
  }

  componentWillMount() {
    if (this.props.user.permissionLevel < 5 && !this.props.user.hijacked) {
      const { dispatch } = this.props
      dispatch(routeActions.push('/dashboard'))
    }
  }

  onChangeQuery(e) {
    this.setState({
      query: e.target.value.trim()
    })
  }

  filteredUsers() {
    let regexp = new RegExp(this.state.query, 'gi')
    return this.state.users.filter(u => regexp.test(u.email) || regexp.test(u.id)).slice(0,50)
  }

  componentDidMount() {
    firebaseRef.child('users').once('value', snap => {
      let users = []
      snap.forEach(s => {
        users.push(Object.assign({}, s.val(), { id: s.key() }))
      })
      this.setState({users})
    }, err => console.log(err))
  }

  hijack(user) {
    const { dispatch } = this.props
    dispatch(hijackUser(user))
  }

  render() {
    return (
      <div className='container-fluid'>
        <div className='panel'>
          <header className='panel-heading'>Select a user</header>
          <div className='panel-body'>
            <input type='text' className='form-control' placeholder='Search' value={this.state.query} onChange={this.onChangeQuery.bind(this)}/>
            <table className='table table-striped table-hover'>
              <thead>
                <tr>
                  <td>id</td>
                  <td>Email</td>
                  <td>Hijack</td>
                </tr>
              </thead>
              <tbody>
                { this.filteredUsers().map(user => {
                  return (
                    <tr key={user.id}>
                      <td>{ user.id }</td>
                      <td>{ user.email }</td>
                      <td><button onClick={this.hijack.bind(this, user.id)} className='btn btn-primary'>Hijack</button></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(state => ({ user: state.auth.user }))(AdminPanel)



/** WEBPACK FOOTER **
 ** ./src/components/admin/AdminPanel.js
 **/